(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yvr-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectors = {
      gift: '.yvr-gift-how, .yvr-gift-experience, .yvr-gift-occasions, .yvr-gift-reviews, .yvr-gift-faq, .yvr-gift-final',
      home: '.yvr-home-trust, .yvr-home-how, .yvr-home-paths, .yvr-home-gifting, .yvr-home-reviews, .yvr-home-faq, .yvr-home-cta'
    };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observer = 'IntersectionObserver' in window && !reducedMotion.matches
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .08 })
      : null;
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-yvr-scroll-reveal-root]').forEach((root) => {
        if (root.dataset.yvrScrollRevealInitialized === 'true') return;
        root.dataset.yvrScrollRevealInitialized = 'true';
        const selector = selectors[root.dataset.yvrScrollRevealPage];
        if (!selector) return;
        document.querySelectorAll(selector).forEach((section) => {
          section.classList.add('yvr-scroll-reveal-target');
          if (observer) observer.observe(section);
          else section.classList.add('is-visible');
        });
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
